import { AccessorySingle } from './singles/AccessorySingle';
import { IAppliance } from '../../interfaces';
import LocalePrice from '@progymedia/gatsby-theme-boutik-ecommerce/src/utils/LocalePrice';
import { ProductSingle } from './singles/ProductSingle';
import React from 'react';
import { VentingSingle } from './singles/VentingSingle';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useProductPrice } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/store/queries/useProductsPriceAndInventories';
import { useSearch } from '../../hooks/useSearch';
import { useTranslation } from 'react-i18next';
import GatsbyImageWrapper from '../GatsbyImageWrapper';
import { popFrontURL } from '../../utils';

export default function SearchList(props: {
    searchString: string;
    isSearchListOpen: boolean;
}) {
    const { t } = useTranslation('layout');
    const { navigateTranslated } = usePageLocalization();
    const { isSearchListOpen, searchString } = props;

    const products = useSearch(searchString).results;

    const productPerfectMatch = getItemKey(
        products.find((product) => product.code == searchString)?.slug?.en_CA,
        null
    )?.key;

    if (isSearchListOpen) {
        return (
            <div className='search-dropdown'>
                {products.length > 0 ? (
                    <>
                        {products.map((product: any, index: number) => {
                            const category = getItemKey(
                                product?.slug?.en_CA,
                                null
                            )?.key;

                            if (
                                (category === 'accessories' ||
                                    category === 'options') &&
                                product?.code
                            ) {
                                if (product?.fields?.images) {
                                    return (
                                        <AccessorySingle
                                            isPerfectMatch={
                                                productPerfectMatch &&
                                                (productPerfectMatch ==
                                                    'accessories' ||
                                                    productPerfectMatch ==
                                                        'options')
                                                    ? true
                                                    : false
                                            }
                                            key={index}
                                            product={product}
                                        />
                                    );
                                }
                                return undefined;
                            } else if (
                                category === 'heaters' &&
                                product?.code
                            ) {
                                return (
                                    <ProductSingle
                                        isPerfectMatch={
                                            productPerfectMatch &&
                                            productPerfectMatch == 'heaters'
                                                ? true
                                                : false
                                        }
                                        key={index}
                                        product={product}
                                        isDiscontinued={product?.slug?.[
                                            'en_CA'
                                        ]?.includes('discontinued')}
                                    />
                                );
                            } else if (
                                category === 'venting' &&
                                product?.code
                            ) {
                                return (
                                    <VentingSingle
                                        isPerfectMatch={
                                            productPerfectMatch &&
                                            productPerfectMatch == 'venting'
                                                ? true
                                                : false
                                        }
                                        key={index}
                                        product={product}
                                    />
                                );
                            } else if (category === 'parts') {
                                return (
                                    <PartSingle
                                        isPerfectMatch={
                                            productPerfectMatch &&
                                            productPerfectMatch == 'parts'
                                                ? true
                                                : false
                                        }
                                        key={`search-list-partsingle-${index}`}
                                        product={product}
                                    />
                                );
                            } else return undefined;
                        })}
                        {products.length > 15 && (
                            <div
                                className='see-more'
                                onClick={() =>
                                    navigateTranslated(
                                        `/search?q=${searchString}`
                                    )
                                }
                            >
                                {t('search.more')}
                            </div>
                        )}{' '}
                    </>
                ) : (
                    <p style={{ textAlign: 'start', margin: '0.8rem' }}>
                        {t('search.no-results')}
                    </p>
                )}
            </div>
        );
    } else {
        return <div style={{ display: 'none' }}></div>;
    }
}

function getItemKey(
    slugs: string | undefined,
    item: any
): { key: string; item: any } {
    if (!slugs) {
        return { key: 'NR', item };
    }
    if (slugs.includes('/cms/blog')) {
        return { key: 'cms', item };
    } else if (slugs.includes('/accessories/')) {
        return { key: 'accessories', item };
    } else if (
        slugs.includes('/archives/') ||
        slugs.includes('/discontinued/')
    ) {
        return { key: 'archives', item };
    } else if (slugs.includes('/heaters/')) {
        return { key: 'heaters', item };
    } else if (slugs.includes('/parts/')) {
        return { key: 'parts', item };
    } else if (slugs.includes('/venting/')) {
        return { key: 'venting', item };
    } else if (slugs.includes('/options/')) {
        return { key: 'options', item };
    } else {
        return { key: 'NR', item };
    }
}

function PartSingle(props: { product: IAppliance; isPerfectMatch: boolean }) {
    const { product, isPerfectMatch } = props;

    const { navigateTranslated, currentLocale } = usePageLocalization();
    const [price] = useProductPrice(product.code as string);

    const navigateToVenting = (product: any) => {
        if (product) {
            const link = popFrontURL(product?.slug?.[currentLocale], 2);
            if (link) {
                navigateTranslated(link);
            }
        }
    };
    return (
        <div
            className={`product ${
                isPerfectMatch ? 'perfect-match' : 'search-part'
            }`}
            onClick={() => {
                navigateToVenting(product);
            }}
        >
            <div className='product-image'>
                <GatsbyImageWrapper fields={product?.fields} />
            </div>
            <div className='product-info'>
                <span className='code'>{product.code}</span>
                <span className='title'>{product?.title?.[currentLocale]}</span>
                {price?.discount ? (
                    <div>
                        <span
                            className='price'
                            style={{
                                textDecoration: 'line-through',
                                marginRight: '10px',
                                color: '#b2aca2',
                            }}
                        >
                            {LocalePrice(
                                currentLocale,
                                price?.regularPrice.value
                            )}
                        </span>
                        <span className='price' style={{ color: '#d65e2a' }}>
                            {LocalePrice(
                                currentLocale,
                                price?.finalPrice.value
                            )}
                        </span>
                    </div>
                ) : (
                    <span className='price'>
                        {LocalePrice(currentLocale, price?.regularPrice.value)}
                    </span>
                )}
            </div>
        </div>
    );
}
